import { FC, useCallback, useEffect, useState } from "react";
import { ChatBodyProps } from "./types";
import { useThemeStore } from "../../../stores";
import ChatBodyHeader from "./chat-body-header";
import { Column } from "../../../components/containers";
import { JustifyContent } from "../../../components/containers/types";
import ChatBodyFooter from "./chat-body-footer";
import ChatBodyChats from "./chat-body-chats";
import { Chat } from "../../../types";

const ChatBody: FC<ChatBodyProps> = ({
  isMobile,
  isSidePanel,
  searchTerm = "",
  setSearchTerm = () => {},
  headerRef,
}) => {
  const theme = useThemeStore((s) => s.theme);

  const background = isSidePanel ? theme.background : theme.overlay;
  const [height, setHeight] = useState<string>("calc(100% - 20px)");

  const [editingChat, setEditingChat] = useState<Chat | null>(null);

  const calcConHeight = useCallback((): void => {
    setTimeout(() => {
      if (!headerRef?.current) return setHeight("calc(100% - 20px)");
      const h = window.getComputedStyle(headerRef.current).height;
      const hn = Number(h.substring(0, h.length - 2));
      setHeight(`calc(100% - 20px - ${hn}px)`);
    }, 200);
  }, [headerRef]);

  useEffect(() => {
    calcConHeight();
  }, [calcConHeight]);

  return (
    <Column
      style={{
        ...styles.container,
        background,
        height,
      }}
      justifyContent={JustifyContent.Between}
    >
      <ChatBodyHeader isSidePanel={isSidePanel} />

      <ChatBodyChats
        setEditingChat={setEditingChat}
        isSidePanel={isSidePanel}
      />

      <ChatBodyFooter
        editingChat={editingChat}
        setEditingChat={setEditingChat}
        isSidePanel={isSidePanel}
      />
    </Column>
  );
};

export default ChatBody;

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: "100%",
    marginTop: 20,
    borderRadius: 25,
  },
};
